module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/main/navbar/horizontal/navbar-horizontal.component.scss
// module id = ./src/app/main/navbar/horizontal/navbar-horizontal.component.scss
// module chunks = main